import { render } from "./ReviewsLabel.vue?vue&type=template&id=3a04e83a"
import script from "./ReviewsLabel.vue?vue&type=script&lang=js"
export * from "./ReviewsLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__